
import { Injectable } from '@angular/core';
import { CtBinaryOperator, CtModelConfiguration, CTModelDatatableFilter, CtModelDatatableOperators, CtModelService } from '@ctsolution/ct-framework';
import { CtWebapiGenericResponse } from '@ctsolution/ct-webapi';
import { FormTemplateRouteData } from 'projects/ct-manager/src/app/_core/route-data/form-template.route-data';
import { WorkOrderDataRouteData } from 'projects/ct-manager/src/app/_core/route-data/work-order-data.route-data';
import { Observable } from 'rxjs';
import { WorkOrderDynamicFormDataParameter } from './work-order-dynamic-form/work-order-dynamic-form.component';

@Injectable({
    providedIn: 'root'
  })
  export class WorkOrderDynamicFormService {
  
    constructor(private modelService: CtModelService<any>) {}
  
    workOrderDataConfiguration(): CtModelConfiguration<any> {
      return CtModelConfiguration
        .create()
        .setRouteData(WorkOrderDataRouteData());
    }
  
    getWorkOrderDynamicForms(typeValue : number, valueCodeFilter: string | null): Observable<CtWebapiGenericResponse<CtModelConfiguration<Array<any>>>> {
      const configuration = CtModelConfiguration
        .create()
        .setRouteData(FormTemplateRouteData());
  
      const filters = CtModelDatatableOperators
        .create()
        .setFilters([
          CTModelDatatableFilter
            .create()
            .setField('Type')
            .setValue(typeValue)
            .setOperatorType(CtBinaryOperator.Equal)
        ]);
  
      if (valueCodeFilter) {
        filters.Filters.push(
          CTModelDatatableFilter.create()
            .setField('Code')
            .setValue(valueCodeFilter)
            .setOperatorType(CtBinaryOperator.Equal)
        );
      } else {
        filters.Filters.push(
          CTModelDatatableFilter.create()
            .setField("[Code] is null OR [Code] = ?")
            .setValue([null])
            .setOperatorType(CtBinaryOperator.OrOperator)
        );
      }
  
      return this.modelService.getList(configuration, filters);
    }
  
    getWorkOrderData(formGeneratorOid: number, workOrderOid: number): Observable<CtWebapiGenericResponse<CtModelConfiguration<Array<WorkOrderDynamicFormDataParameter>>>> {
      const filters = CtModelDatatableOperators
        .create()
        .setFilters([
          CTModelDatatableFilter
            .create()
            .setField('WorkOrder.Oid')
            .setValue(workOrderOid)
            .setOperatorType(CtBinaryOperator.Equal),
          CTModelDatatableFilter
            .create()
            .setField('FormTemplate.Oid')
            .setValue(formGeneratorOid)
            .setOperatorType(CtBinaryOperator.Equal)
        ]);
  
      return this.modelService.getList(this.workOrderDataConfiguration(), filters);
    }
  
    generateWorkOrderDynamicFormDataParameter(params: { value: any, formGeneratorOid: number, workOrderOid: number }): WorkOrderDynamicFormDataParameter {
      return WorkOrderDynamicFormDataParameter
        .create()
        .setContent(JSON.stringify(params.value))
        .setFormGeneratorOid(params.formGeneratorOid)
        .setWorkOrder(params.workOrderOid);
    }
  
    insertWorkOrderData(parameter: WorkOrderDynamicFormDataParameter): Observable<CtWebapiGenericResponse<number | null>> {
      const workOrderConfiguration = this.workOrderDataConfiguration();
      if (parameter.Oid) {
        workOrderConfiguration.RouteData?.setId(parameter.Oid);
      }
      return this.modelService.putInfos(workOrderConfiguration, parameter)!;
    }

    getFormWorkOrderDataValue(formGeneratorOid: number, workOrderOid : number): Promise<WorkOrderDynamicFormDataParameter | null> {

      return new Promise((resolve, reject) => {

        this.getWorkOrderData(formGeneratorOid,workOrderOid)
          .subscribe((response: CtWebapiGenericResponse<CtModelConfiguration<Array<WorkOrderDynamicFormDataParameter>>>) => {

              const result = (<WorkOrderDynamicFormDataParameter[]>response.Result.DataSource ?? []);

              if (result.length) {

                const dataSource: WorkOrderDynamicFormDataParameter = result[0];
                resolve(dataSource);

              }

              resolve(null);

            },
            (error) => reject(error)
          );
      });

    }


  }
  